import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  submit(event) {
    // Blur the input that triggered the change. When a turbo_stream
    // response then mutates the DOM (e.g. the row is removed and
    // re-appended in a new section), the browser would otherwise jump
    // focus to the next focusable input — on iOS, that pops the keyboard
    // up over an unrelated form. Explicitly blurring keeps the page calm.
    event?.target?.blur?.()

    const formId = this.element.getAttribute("form")
    const form = formId ? document.getElementById(formId) : this.element.closest("form")
    if (form) form.requestSubmit()
  }

  debounce(event) {
    clearTimeout(this._timer)
    this._timer = setTimeout(() => this.submit(event), 300)
  }

  toggleFilters() {
    const panel = this.element.querySelector("[data-form-submit-panel]")
    if (panel) panel.classList.toggle("hidden")
  }

  disconnect() {
    clearTimeout(this._timer)
  }
}
